/**
 * Admin-only "view the app as a user".
 *
 * The system Admin picks a person and from then on every request carries that person's id in X-Assume-User; the server
 * (lib/auth-jwt.js) answers as them, with their role, permissions and own-profile and team scopes, so the Admin sees
 * exactly what they see. It is read-only (the server refuses any write while it is on) and the audit log keeps the
 * real Admin.
 *
 * Stored per tab (sessionStorage), so a forgotten view cannot follow the Admin into a new tab.
 */
export const ASSUME_USER_STORAGE_KEY = 'wfm.assumeUser';
export const ASSUME_USER_HEADER = 'X-Assume-User';

/** The roles that may view the app as another user: the same list the server takes (ADMIN_LIKE_ROLES in backend/lib/rbac.js). */
export const ASSUME_ROLES = ['admin', 'zendesk_administrator', 'head_of_cs'];
export const canAssumeUsers = (role) => ASSUME_ROLES.includes(String(role || '').trim().toLowerCase());

/** The person being viewed as, { id, name }, or null. */
export const readAssumedUser = () => {
  try {
    const raw = JSON.parse(sessionStorage.getItem(ASSUME_USER_STORAGE_KEY) || 'null');
    return raw && Number.isInteger(Number(raw.id)) && Number(raw.id) > 0 ? { id: Number(raw.id), name: String(raw.name || '') } : null;
  } catch {
    return null;
  }
};

export const writeAssumedUser = (person) => {
  try {
    if (person && person.id != null) sessionStorage.setItem(ASSUME_USER_STORAGE_KEY, JSON.stringify({ id: Number(person.id), name: String(person.name || '') }));
    else sessionStorage.removeItem(ASSUME_USER_STORAGE_KEY);
  } catch {
    /* private mode / blocked storage: the view just will not survive a reload */
  }
};

/** A request that must be sent as the real account (starting or ending the view, asking who the real user is). */
export const AS_REAL_ACCOUNT = { [ASSUME_USER_HEADER]: '' };
